exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination > li > a {\n  color: #4dc0b5;\n}\n.pagination > li > a:hover {\n  background-color: #4dc0b5 !important;\n  color: white;\n}\nli.page-item.active > a {\n  background-color: #4dc0b5 !important;\n  border-color: #4dc0b5 !important;\n}\na.page-link:focus {\n  box-shadow: none;\n}\n", ""]);

// exports
